import { render, staticRenderFns } from "./BindingDevice.vue?vue&type=template&id=dfeffe78&scoped=true&"
import script from "./BindingDevice.vue?vue&type=script&lang=js&"
export * from "./BindingDevice.vue?vue&type=script&lang=js&"
import style0 from "./BindingDevice.vue?vue&type=style&index=0&id=dfeffe78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfeffe78",
  null
  
)

export default component.exports